import { useState, useEffect } from "react";
import { TextField, Button, Typography, Stack } from "@mui/material";

/**
 * A component that displays a value and allows editing
 * @param {object} props
 * @param {string} props.initialValue - The starting value to display
 * @param {function(string): Promise<void>} props.onSave - Asynchronous function to call with the new value when saving
 * @param {function(string): (string | null)} [props.validate] - Optional function to validate the value
 */
const EditableField = ({ initialValue, onSave, validate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(initialValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleValueChange = (newValue) => {
    setValue(newValue);
    if (validate) {
      setError(validate(newValue));
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(value);
      setIsEditing(false);
    } catch (error) {
      setError("No se pudo actualizar el email");
      console.error("Falló el guardado:", error);
    } finally {
      setLoading(false);
    }
  };

  if (isEditing) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          variant="outlined"
          size="small"
          value={value}
          onChange={(e) => handleValueChange(e.target.value)}
          disabled={loading}
          error={!!error}
          helperText={error}
        />
        <Button
          size="small"
          variant="contained"
          onClick={handleSave}
          disabled={loading || !!error}
          sx={{
            marginTop: "30px !important",
            borderRadius: "0px !important",
            fontWeight: "bolder !important",
            fontSize: "1rem !important"
          }}
        >
          {loading ? "..." : "Guardar"}
        </Button>
        <Button
          size="small"
          variant="text"
          onClick={() => setIsEditing(false)}
          disabled={loading}
          sx={{
            marginTop: "30px !important",
            borderRadius: "0px !important",
            fontWeight: "bolder !important",
            fontSize: "1rem !important"
          }}
        >
          Cancelar
        </Button>
      </Stack>
    );
  }

  return (
    <>
      <Typography variant="body1">{initialValue}</Typography>
      <Button
        size="small"
        variant="text"
        onClick={() => setIsEditing(true)}
        sx={{
          borderRadius: "0px !important",
          fontWeight: "bolder !important",
          fontSize: "1rem !important"
        }}
      >
        editar
      </Button>
    </>
  );
};

export default EditableField;
